import React from "react";
import { getPublicUrl } from "../../../../helpers/helper_functions";
import { InfoImage } from "./SharedComponents";

import "./InfoBox.css";

const EnvironmentInfo = () => {
  return (
    <div className="info-box-wrapper right-box">
      <p className="info-text-title">
        Factory farming does enormous environmental damage
      </p>
      <div className="info-text-body">
        <p>
          {" "}
          Animal agriculture contributes to nearly 20% of all human-created
          greenhouse gas emissions. Producing and transporting animals and their
          feed, destroying forests to expand grazing pastures, meat-packing and
          processing, manure management, and enteric fermentation in animals'
          stomachs are costly for the environment.
        </p>
        <p>
          Why are we destroying our planet? Switching to a plant-based diet can
          reduce an individual's annual carbon footprint by nearly 33% or 2.1
          tons!
        </p>
      </div>
    </div>
  );
};

const EnvironmentImage = () => {
  return (
    <InfoImage
      className="info-box-image"
      $background_image={getPublicUrl("assets/Home/burning-forest.jpg")}
      $background_image_details={"no-repeat 67% 30%"}
    ></InfoImage>
  );
};

export default {
  info: () => <EnvironmentInfo />,
  image: () => <EnvironmentImage />,
};

// source: https://thebreakthrough.org/issues/food-agriculture-environment/livestock-dont-contribute-14-5-of-global-greenhouse-gas-emissions#:~:text=More%20recent%20data%20and%20science,up%20to%2019.6%25%20of%20emissions.
// source: https://www.un.org/en/actnow/food#:~:text=Switching%20to%20a%20plant%2Dbased,for%20a%20particular%20meal(ex.
